module.exports = __webpack_public_path__ + "static/media/Pheromosa_gaussian2.f0739fd4.png";